import {
  spfOne,
  spfTwo,
  spfThree,
  spfFour,
  bestSellerOne,
  bestSellerTwo,
  bestSellerThree,
  bestSellerFour,
  newArrOne,
  newArrTwo,
  newArrThree,
  newArrFour,
} from "../assets/images/index";

// =================== NavBarList Start here ====================
export const navBarList = [
  {
    _id: 1001,
    title: "Home",
    link: "/",
  },
  {
    _id: 1002,
    title: "Repair",
    link: "/shop",
  },
  {
    _id: 1003,
    title: "About",
    link: "/about",
  },
  {
    _id: 1004,
    title: "Contact",
    link: "contact",
  },
  {
    _id: 1005,
    title: "Journal",
    link: "/journal",
  },
];
// =================== NavBarList End here ======================
// =================== Special Offer data Start here ============
export const SplOfferData = [
  {
    _id: "201",
    img: spfOne,
    productName: "",
    price: "",
    color: "repairs",
    badge: true,
    des: "available.",
  },
  {
    _id: "202",
    img: newArrFour,
    productName: "",
    price: "",
    color: "repairs",
    badge: true,
    des: "available.",
  },
  {
    _id: "203",
    img: spfThree,
    productName: "",
    price: "",
    color: "repairs",
    badge: true,
    des: "available.",
  },
  {
    _id: "204",
    img: spfFour,
    productName: "",
    price: "",
    color: "repairs",
    badge: true,
    des: "available.",
  },
];
// =================== Special Offer data End here ==============

// =================== PaginationItems Start here ===============

export const paginationItems = [
  {
    _id: 1001,
    img: spfOne,
    productName: "",
    price: "",
    color: "repairs",
    badge: true,
    des: "available.",
  },
  {
    _id: 1002,
    img: spfTwo,
    productName: "",
    price: "",
    color: "repairs",
    badge: true,
    des: "available.",
  },
  {
    _id: 1003,
    img: spfThree,
    productName: "",
    price: "",
    color: "repairs",
    badge: true,
    des: "available.",
  },
  {
    _id: 1004,
    img: spfFour,
    productName: "",
    price: "",
    color: "repairs",
    badge: true,
    des: "available.",
  },
  {
    _id: 1005,
    img: bestSellerOne,
    productName: "",
    price: "",
    color: "repairs",
    badge: true,
    des: "available.",
  },
  {
    _id: 1006,
    img: bestSellerTwo,
    productName: "",
    price: "",
    color: "repairs",
    badge: false,
    des: "available.",
  },
  {
    _id: 1007,
    img: bestSellerThree,
    productName: "",
    price: "",
    color: "repairs",
    badge: true,
    des: "available.",
  },
  {
    _id: 1008,
    img: bestSellerFour,
    productName: "",
    price: "",
    color: "repairs",
    badge: false,
    des: "available.",
  },
  {
    _id: 1009,
    img: newArrOne,
    productName: "",
    price: "",
    color: "buy",
    badge: true,
    des: "available.",
  },
  {
    _id: 1010,
    img: newArrTwo,
    productName: "",
    price: "",
    color: "buy",
    badge: true,
    des: "available.",
  },
  {
    _id: 1011,
    img: newArrThree,
    productName: "",
    price: "",
    color: "buy",
    badge: true,
    des: "available.",
  },
  
  {
    _id: 1046,
    img: spfOne,
    productName: "",
    price: "",
    color: "repairs",
    badge: true,
    des: "available.",
  },
];
// =================== PaginationItems End here =================
